@if (formGroup) {
  <div [formGroup]="formGroup">
    <div class="row">
      <div class="form-group col-md-3">
        <label>{{ 'content.social-insurance-number-short' | translate }}
          <input appHideOnBlur class="form-control" type="text" autocomplete="on" mask="000-000-000" placeholder="" [formControlName]="sinControlName" #sinControlNameInput>
        </label>
        <app-validation-errors [displayErrors]="displayErrors" [errors]="[formGroup.errors, formGroup.controls[sinControlName].errors]" [element]="sinControlNameInput"></app-validation-errors>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <!-- TODO: (feature) date picker -->
        <label>{{ 'content.person.dob' | translate }}
          <input appHideOnBlur class="form-control" type="text" autocomplete="on" mask="0000-00-00" placeholder="yyyy-mm-dd" [formControlName]="dobControlName" #dobControlNameInput>
        </label>
        <!-- TODO: (feature) validate it's a real date -->
        <app-validation-errors [displayErrors]="displayErrors" [errors]="[formGroup.errors, formGroup.controls[dobControlName].errors]" [element]="dobControlNameInput"></app-validation-errors>
      </div>
    </div>
  </div>
}
